export default __webpack_public_path__ + "static/media/4.2197e7ea.mp3";